import * as yup from "yup";
import {stringRequired} from "yup/defaultValudations";

export const schema = yup.object().shape({
  price: stringRequired(),
  validUntil: yup.string().required("Field is required"),
  message: yup.string().nullable(),
});
